<template>
  <div
    class="year-wrap"
    :class="fadeClasses"
  >
    <p
      ref="year"
      class="year"
    >
      <slot></slot>
    </p>
  </div>
</template>

<script>
import { TweenMax, Power0 } from 'gsap'
import { fadeMixin } from '@/mixins'

export default {
  name: 'Year',
  props: {
    theme: {
      type: String,
      default: 'light',
      validator: function (value) {
        return ['light', 'dark', 'blue'].indexOf(value) !== -1
      }
    }
  },
  mixins: [fadeMixin],
  mounted () {
    const scene = this.$scrollmagic.scene({
      triggerHook: 1,
      triggerElement: this.$refs.year,
      duration: '200%'
    })

    this.$scrollmagic.addScene(
      scene
        .setTween(TweenMax.to(this.$refs.year, 1, {
          y: '20%',
          ease: Power0.easeNone
        }))
    )
  }
}
</script>

<style lang="scss" scoped>
.year {
  font-size: 160px;
  line-height: $lh-heading;
  text-align: center;
  font-weight: $fw-bold;

  @media (max-width: 374px) {
    font-size: 130px;
  }

  @media (min-width: 768px) {
    font-size: 260px;
  }
}
</style>
